// for debug mode
consoleLog = function(...args) {
    if (APP_DEBUG) {
        console.log(args);
    }
}
swalMessage = function(msg, title) {
    Swal.fire({
        title: `<b style="font-size: 0.8em;">${title}</b>`,
        text: msg,
        // imageUrl: "https://unsplash.it/400/200",
        // imageWidth: 400,
        // imageHeight: 200,
        padding: "3em",
        color: "#000",
        background: "#dddddd",
        showCancelButton: false,
        showConfirmButton: false
    });
}

swalHtml = function(html_content,title = ""){
    Swal.fire({
        title:  `<strong>${title}</strong>`,
        icon: 'info',
        html: html_content,
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText:
            '<i class="fa fa-thumbs-up"></i> موافق',
        confirmButtonAriaLabel: 'Thumbs up, great!',
        cancelButtonText:
            '<i class="fa fa-thumbs-down"></i>',
        cancelButtonAriaLabel: 'Thumbs down'
    });
}
swalInfo = function(msg, title = '') {


    swal.fire(
        {
            title: title,
            text: msg,
            icon: "info",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'موافق',
        }
    );
}
swalException = function() {

    swal.fire(
        {
            text: 'حدث خطأ في العملية !!!',
            icon: "error",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: "موافق",
        }
    );
}

swalWarning = function(msg = '', title = '') {

    swal.fire(
        {
            title: title,
            html: msg ? msg :'حدث خطأ في العملية !!!',
            icon: "warning",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'موافق',
        }
    );
}

swalSuccess = function(msg = '', title = '') {

    swal.fire(
        {
            title: title,
            text: msg ? msg :'تمت العملية بنجاح',
            icon: "success",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'موافق',
        }
    );
}

swalError = function(msg = '', title = '') {

    swal.fire(
        {
            title: title,
            html: msg ? msg :'حدث خطأ ما ',
            icon: "error",
            timer: 5000,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'موافق',
        }
    );
}


toastException = function() {

    toastr.error('حدث خطأ في العملية !!!')
}

toastWarning = function(msg = '', title = '') {

    toastr.warning(msg ? msg : 'حدث خطأ في العملية !!!', title);

}

toastSuccess = function(msg = '', title = '') {
    toastr.success(msg ? msg : 'تمت العملية بنجاح', title);

}

toastError = function(msg = '', title = '') {
    toastr.error(msg ? msg : 'حدث خطأ ما ', title);

}

printLaravelErrors = function(errors, container = null, message = null) {
    $('.added-items').remove();

    let errorsHtml =
        '<div class="alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40 added-items" role="alert">' +
        '<div class="alert-icon"><i class="fa fa-exclamation-triangle"></i></div>' +
        '<div class="alert-text">لديك بعض الأخطاء في الأسفل تحقق منها !!';


    if (errors) {
        $.each(errors, function (key, value) {
            errorsHtml += '<li>' + value + '</li>';
        });
    } else if (message) {

        errorsHtml += '<li>' + message + '</li>';

    }


    errorsHtml += '</div> <div class="alert-close">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true"><i class="la la-close"></i></span>' +
        '</button>' +
        '</div>' +
        '</div>';

    if (container)
        container.append(errorsHtml);
    else
        $('#validation_alert').append(errorsHtml);
}

stayInSameTabAfterPageRefresh = function() {
    $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
        localStorage.setItem('activeTab', $(e.target).attr('href'));
    });
    var activeTab = localStorage.getItem('activeTab');
    consoleLog(activeTab);
    if (activeTab) {
        $('a[href="' + activeTab + '"]').tab('show');
    }
}


printLaravelErrorsV2 = function(errors, formElement, message = null) {


    formElement.find('.form_validation_errors_v2').remove();

    let errorsHtml =
        '<div class="alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40 form_validation_errors_v2" role="alert">' +
        '<div class="alert-icon"><i class="fa fa-exclamation-triangle"></i></div>' +
        '<div class="alert-text">لديك بعض الأخطاء في الأسفل تحقق منها !!';


    if (errors) {
        $.each(errors, function (key, value) {
            errorsHtml += '<li>' + value + '</li>';
        });
    } else if (message) {

        errorsHtml += '<li>' + message + '</li>';

    }


    errorsHtml += '</div> <div class="alert-close">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true"><i class="la la-close"></i></span>' +
        '</button>' +
        '</div>' +
        '</div>';


    formElement.prepend(errorsHtml);


}

confirmProcess = function (title ,text,
                           confirmCallback = null, confirmCallbackParams = [],
                           cancelCallback = null, cancelCallbackParams = []) {

    swal.fire({
        title: title,
        text: text,
        icon: "warning",
        dangerMode: true,
        showCancelButton: true,
        confirmButtonColor: '#0abb87',
        cancelButtonColor: '#d33',
        confirmButtonText: 'نعم',
        cancelButtonText: 'إلغاء الأمر',

    })
        .then(willDelete => {
            if (willDelete.value) {
                if (confirmCallback) {
                    confirmCallback.apply(this, confirmCallbackParams);
                }
            } else {
                if (cancelCallback) {
                    cancelCallback.apply(this, cancelCallbackParams);
                }

            }
        });


};

